const config = {
  apiUrl: process.env.REACT_APP_API_URL ?? 'https://api.hetheraengineering.com/',
  callbackUrlBase: 'https://Hethera.hetheraengineering.com/',
};

export default config;
